<wl-calculate-card [title]="rendering().fields.Title">
  <form
    [formGroup]="homeBatteryForm()"
    (submit)="submit()"
    [wlTrackStep]="trackToolConfig().forStep('homebattery-check')"
    class="mt-2"
  >
    <rfa-address
      [form]="homeBatteryForm().controls.address"
      [addressCheckService]="addressCheckService()"
    />
    <fieldset class="position-relative">
      <button
        type="button"
        class="btn btn-link align-self-end p-0 position-absolute end-0"
        (click)="openEstimationModal()"
        wlAutomationId="homebattery-wizard-estimate-button"
      >
        {{ rendering() | scFieldValue: 'ConsumptionEstimateButtonText' }}
      </button>
      <rfa-number-input
        class="mb-0"
        [control]="homeBatteryForm().controls.consumptionPerYear"
      />
      <p class="fst-italic">
        {{ rendering() | scFieldValue: 'AverageConsumptionText' }}
      </p>
    </fieldset>
    <crnt-button
      class="w-100 mt-2"
      type="submit"
      wlAutomationId="homebattery-wizard--submit-button"
    >
      {{ rendering() | scFieldValue: 'SubmitButtonText' }}
      <crnt-icon slot="trailing" icon="arrow-right" />
    </crnt-button>
  </form>
</wl-calculate-card>
